import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/h5/');

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();

    const imgMap: any = {
        us: ['95.webp', '95.jpg'],
        au: ['99.webp', '99.png'],
    };

    return (
        <div className={`${css.imgA} imgA GtmModuleData-section`} data-section-id={css.imgA} data-section-title={t('delta2.aniE_msg1')}>
            <div className={locale === 'jp' ? 'jp-fill' : ''}>
                <div className="img-item">
                    <EFPic name={imgMap[locale] || imgMap.us} loading="eager" />
                </div>
                <div className="v-msg">
                    <div className="v-msg-1">{t('delta2.aniE_msg1')}</div>
                    <div className="v-msg-2">{t('delta2.aniE_msg2')}</div>
                </div>
            </div>
        </div>
    );
}
